import { render, staticRenderFns } from "./AnonymisationOverallConfiguration.vue?vue&type=template&id=198cb2b1&"
import script from "./AnonymisationOverallConfiguration.vue?vue&type=script&lang=ts&"
export * from "./AnonymisationOverallConfiguration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports